module.exports = __webpack_public_path__ + "fonts/SpareBank1Title-Regular-Web.58497f4.woff";